export default __webpack_public_path__ + "static/meaningImg-c3ba2fdbf9a934299fa401b148777642.png";